import {
  GET_MESSAGING_CONVERSATION_LIST,
  GET_MESSAGING_CONVERSATION_LIST_SUCCESS,
  GET_MESSAGING_CONVERSATION_LIST_FAILURE,
  SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST,
  SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_SUCCESS,
  SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_FAILURE,
  SEND_MESSAGING_CONVERSATION_MESSAGE,
  SEND_MESSAGING_CONVERSATION_MESSAGE_SUCCESS,
  SEND_MESSAGING_CONVERSATION_MESSAGE_FAILURE,
  UPDATE_MESSAGING_CONVERSATION,
  UPDATE_MESSAGING_CONVERSATION_SUCCESS,
  UPDATE_MESSAGING_CONVERSATION_FAILURE,
  CREATE_MESSAGING_CONVERSATION,
  CREATE_MESSAGING_CONVERSATION_SUCCESS,
  CREATE_MESSAGING_CONVERSATION_FAILURE,
  GET_MESSAGING_CHANNEL_LIST,
  GET_MESSAGING_CHANNEL_LIST_SUCCESS,
  GET_MESSAGING_CHANNEL_LIST_FAILURE,
  START_MESSAGING_CONVERSATION_MESSAGE,
  START_MESSAGING_CONVERSATION_MESSAGE_SUCCESS,
  START_MESSAGING_CONVERSATION_MESSAGE_FAILURE,
  SEARCH_MESSAGING_CONVERSATION_TEMPLATE,
  SEARCH_MESSAGING_CONVERSATION_TEMPLATE_SUCCESS,
  SEARCH_MESSAGING_CONVERSATION_TEMPLATE_FAILURE,
  REMOVE_MESSAGING_CONVERSATION_PARTICIPANT,
  REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_SUCCESS,
  REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_FAILURE,
  MARK_MESSAGING_CONVERSATION_READ,
  MARK_MESSAGING_CONVERSATION_READ_SUCCESS,
  MARK_MESSAGING_CONVERSATION_READ_FAILURE,
  MARK_MESSAGING_CONVERSATION_UNREAD,
  MARK_MESSAGING_CONVERSATION_UNREAD_SUCCESS,
  MARK_MESSAGING_CONVERSATION_UNREAD_FAILURE,
  MARK_MESSAGING_CONVERSATION_MESSAGE_READ,
  MARK_MESSAGING_CONVERSATION_MESSAGE_READ_SUCCESS,
  MARK_MESSAGING_CONVERSATION_MESSAGE_READ_FAILURE,
  MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD,
  MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_SUCCESS,
  MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_FAILURE,
  GET_MESSAGING_CONVERSATION_DATA,
  GET_MESSAGING_CONVERSATION_DATA_SUCCESS,
  GET_MESSAGING_CONVERSATION_DATA_FAILURE,
  SET_SELECTED_MESSAGING_CONVERSATION,
  SET_SELECTED_MESSAGING_CONVERSATION_SUCCESS,
  SET_SELECTED_MESSAGING_CONVERSATION_FAILURE,
  CLOSE_MESSAGING_CONVERSATION,
  CLOSE_MESSAGING_CONVERSATION_SUCCESS,
  CLOSE_MESSAGING_CONVERSATION_FAILURE,
} from "./actionType";

//actions

//GET_MESSAGING_CONVERSATION_LIST
export const getMessagingConversationList = (payload) => {
  return {
    type: GET_MESSAGING_CONVERSATION_LIST,
    payload,
  };
};
export const getMessagingConversationListSuccess = (payload) => {
  return {
    type: GET_MESSAGING_CONVERSATION_LIST_SUCCESS,
    payload,
  };
};
export const getMessagingConversationListFailure = (payload) => {
  return {
    type: GET_MESSAGING_CONVERSATION_LIST_FAILURE,
    payload,
  };
};

//SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST
export const searchMessagingConversationMessageList = (payload) => {
  return {
    type: SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST,
    payload,
  };
};
export const searchMessagingConversationMessageListSuccess = (payload) => {
  return {
    type: SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_SUCCESS,
    payload,
  };
};
export const searchMessagingConversationMessageListFailure = (payload) => {
  return {
    type: SEARCH_MESSAGING_CONVERSATION_MESSAGE_LIST_FAILURE,
    payload,
  };
};

//SEND_MESSAGING_CONVERSATION_MESSAGE
export const sendMessagingConversationMessage = (payload) => {
  return {
    type: SEND_MESSAGING_CONVERSATION_MESSAGE,
    payload,
  };
};
export const sendMessagingConversationMessageSuccess = (payload) => {
  return {
    type: SEND_MESSAGING_CONVERSATION_MESSAGE_SUCCESS,
    payload,
  };
};
export const sendMessagingConversationMessageFailure = (payload) => {
  return {
    type: SEND_MESSAGING_CONVERSATION_MESSAGE_FAILURE,
    payload,
  };
};

//UPDATE_MESSAGING_CONVERSATION
export const updateMessagingConversation = (payload) => {
  return {
    type: UPDATE_MESSAGING_CONVERSATION,
    payload,
  };
};
export const updateMessagingConversationSuccess = (payload) => {
  return {
    type: UPDATE_MESSAGING_CONVERSATION_SUCCESS,
    payload,
  };
};
export const updateMessagingConversationFailure = (payload) => {
  return {
    type: UPDATE_MESSAGING_CONVERSATION_FAILURE,
    payload,
  };
};

//CREATE_MESSAGING_CONVERSATION
export const createMessagingConversation = (payload) => {
  return {
    type: CREATE_MESSAGING_CONVERSATION,
    payload,
  };
};
export const createMessagingConversationSuccess = (payload) => {
  return {
    type: CREATE_MESSAGING_CONVERSATION_SUCCESS,
    payload,
  };
};
export const createMessagingConversationFailure = (payload) => {
  return {
    type: CREATE_MESSAGING_CONVERSATION_FAILURE,
    payload,
  };
};

//GET_MESSAGING_CHANNEL_LIST
export const getMessagingChannelList = (payload) => {
  return {
    type: GET_MESSAGING_CHANNEL_LIST,
    payload,
  };
};
export const getMessagingChannelListSuccess = (payload) => {
  return {
    type: GET_MESSAGING_CHANNEL_LIST_SUCCESS,
    payload,
  };
};
export const getMessagingChannelListFailure = (payload) => {
  return {
    type: GET_MESSAGING_CHANNEL_LIST_FAILURE,
    payload,
  };
};

//START_MESSAGING_CONVERSATION_MESSAGE
export const startMessagingConversationMessage = (payload) => {
  return {
    type: START_MESSAGING_CONVERSATION_MESSAGE,
    payload,
  };
};
export const startMessagingConversationMessageSuccess = (payload) => {
  return {
    type: START_MESSAGING_CONVERSATION_MESSAGE_SUCCESS,
    payload,
  };
};
export const startMessagingConversationMessageFailure = (payload) => {
  return {
    type: START_MESSAGING_CONVERSATION_MESSAGE_FAILURE,
    payload,
  };
};
//SEARCH_MESSAGING_CONVERSATION_TEMPLATE
export const searchMessagingConversationTemplate = (payload) => {
  return {
    type: SEARCH_MESSAGING_CONVERSATION_TEMPLATE,
    payload,
  };
};
export const searchMessagingConversationTemplateSuccess = (payload) => {
  return {
    type: SEARCH_MESSAGING_CONVERSATION_TEMPLATE_SUCCESS,
    payload,
  };
};
export const searchMessagingConversationTemplateFailure = (payload) => {
  return {
    type: SEARCH_MESSAGING_CONVERSATION_TEMPLATE_FAILURE,
    payload,
  };
};

//REMOVE_MESSAGING_CONVERSATION_PARTICIPANT
export const removeMessagingConversationParticipant = (payload) => {
  return {
    type: REMOVE_MESSAGING_CONVERSATION_PARTICIPANT,
    payload,
  };
};
export const removeMessagingConversationParticipantSuccess = (payload) => {
  return {
    type: REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_SUCCESS,
    payload,
  };
};
export const removeMessagingConversationParticipantFailure = (payload) => {
  return {
    type: REMOVE_MESSAGING_CONVERSATION_PARTICIPANT_FAILURE,
    payload,
  };
};

//MARK_MESSAGING_CONVERSATION_READ
export const markMessagingConversationRead = (payload) => {
  return {
    type: MARK_MESSAGING_CONVERSATION_READ,
    payload,
  };
};
export const markMessagingConversationReadSuccess = (payload) => {
  return {
    type: MARK_MESSAGING_CONVERSATION_READ_SUCCESS,
    payload,
  };
};
export const markMessagingConversationReadFailure = (payload) => {
  return {
    type: MARK_MESSAGING_CONVERSATION_READ_FAILURE,
    payload,
  };
};
//MARK_MESSAGING_CONVERSATION_UNREAD
export const markMessagingConversationUnread = (payload) => {
  return {
    type: MARK_MESSAGING_CONVERSATION_UNREAD,
    payload,
  };
};
export const markMessagingConversationUnreadSuccess = (payload) => {
  return {
    type: MARK_MESSAGING_CONVERSATION_UNREAD_SUCCESS,
    payload,
  };
};
export const markMessagingConversationUnreadFailure = (payload) => {
  return {
    type: MARK_MESSAGING_CONVERSATION_UNREAD_FAILURE,
    payload,
  };
};
//MARK_MESSAGING_CONVERSATION_MESSAGE_READ
export const markMessagingConversationMessageRead = (payload) => {
  return {
    type: MARK_MESSAGING_CONVERSATION_MESSAGE_READ,
    payload,
  };
};
export const markMessagingConversationMessageReadSuccess = (payload) => {
  return {
    type: MARK_MESSAGING_CONVERSATION_MESSAGE_READ_SUCCESS,
    payload,
  };
};
export const markMessagingConversationMessageReadFailure = (payload) => {
  return {
    type: MARK_MESSAGING_CONVERSATION_MESSAGE_READ_FAILURE,
    payload,
  };
};
//MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD
export const markMessagingConversationMessageUnread = (payload) => {
  return {
    type: MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD,
    payload,
  };
};
export const markMessagingConversationMessageUnreadSuccess = (payload) => {
  return {
    type: MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_SUCCESS,
    payload,
  };
};
export const markMessagingConversationMessageUnreadFailure = (payload) => {
  return {
    type: MARK_MESSAGING_CONVERSATION_MESSAGE_UNREAD_FAILURE,
    payload,
  };
};

//GET_MESSAGING_CONVERSATION_DATA
export const getMessagingConversationData = (payload) => {
  return {
    type: GET_MESSAGING_CONVERSATION_DATA,
    payload,
  };
};
export const getMessagingConversationDataSuccess = (payload) => {
  return {
    type: GET_MESSAGING_CONVERSATION_DATA_SUCCESS,
    payload,
  };
};
export const getMessagingConversationDataFailure = (payload) => {
  return {
    type: GET_MESSAGING_CONVERSATION_DATA_FAILURE,
    payload,
  };
};

//SET_SELECTED_MESSAGING_CONVERSATION
export const setSelectedMessagingConversation = (payload) => {
  return {
    type: SET_SELECTED_MESSAGING_CONVERSATION,
    payload,
  };
};
export const setSelectedMessagingConversationSuccess = (payload) => {
  return {
    type: SET_SELECTED_MESSAGING_CONVERSATION_SUCCESS,
    payload,
  };
};
export const setSelectedMessagingConversationFailure = (payload) => {
  return {
    type: SET_SELECTED_MESSAGING_CONVERSATION_FAILURE,
    payload,
  };
};

//CLOSE_MESSAGING_CONVERSATION
export const closeMessagingConversation = (payload) => {
  return {
    type: CLOSE_MESSAGING_CONVERSATION,
    payload,
  };
};
export const closeMessagingConversationSuccess = (payload) => {
  return {
    type: CLOSE_MESSAGING_CONVERSATION_SUCCESS,
    payload,
  };
};
export const closeMessagingConversationFailure = (payload) => {
  return {
    type: CLOSE_MESSAGING_CONVERSATION_FAILURE,
    payload,
  };
};
